@if (controlStates.isTopFader && state.isTouchDevice) {
  <div class="top-fader"></div>
}
@if (controlStates.isLeftFader && state.isTouchDevice) {
  <div class="left-fader"></div>
}
<div
  class="virtual-horizontal-scroll"
  #horizontalVirtualScroll
  [ngClass]="{
    isShown:
      !isIOS && controlStates.isVirtualHorizontalScrollShown && isScrollActive,
  }"
>
  <div
    class="scrollbar-track"
    [ngStyle]="{
      'width.px': dragStates.horizontalDragWidth,
      transform: 'translateX(' + dragStates.dragLeft + 'px)',
    }"
  ></div>
</div>
<div
  class="virtual-vertical-scroll"
  #verticalVirtualScroll
  [ngClass]="{
    isShown:
      !isIOS && controlStates.isVirtualVerticalScrollShown && isScrollActive,
  }"
>
  <div
    class="scrollbar-track"
    [ngStyle]="{
      'height.px': dragStates.verticalDragHeight,
      transform: 'translateY(' + dragStates.dragTop + 'px)',
    }"
  ></div>
</div>
<div class="content-scrollbar" (scroll)="onScroll($event)">
  <ng-content></ng-content>
</div>
@if (controlStates.isRightFader && state.isTouchDevice) {
  <div class="right-fader"></div>
}
@if (controlStates.isBottomFader && state.isTouchDevice) {
  <div class="bottom-fader"></div>
}
@if (controlStates.isVertical) {
  <div class="btn-group-vertical scroll-btn-group">
    <div class="up-holder">
      @if (controlStates.showTopBtnFullContent) {
        <button
          class="x_btn x_bordered icon-angle-double-up-line"
          (click)="scrollFullContentVertically('FULL_TOP')"
          [disabled]="controlStates.isTopBtnFullContentDisabled"
        ></button>
      }
      @if (controlStates.showTopBtn) {
        <button
          class="x_btn x_bordered icon-angle-up-line"
          (click)="scrollScreenVertically('TOP')"
          [disabled]="controlStates.isTopBtnDisabled"
        ></button>
      }
      <button
        class="x_btn x_bordered icon-angle-up"
        [attr.e2e-attr]="E2E_ATTRIBUTES.SCROLL_UP_BUTTON"
        (click)="scrollStepVertically('TOP')"
        [disabled]="controlStates.isTopBtnDisabled"
      ></button>
    </div>
    <div class="down-holder">
      <button
        class="x_btn x_bordered icon-angle-down"
        [attr.e2e-attr]="E2E_ATTRIBUTES.SCROLL_BOTTOM_BUTTON"
        (click)="scrollStepVertically('BOTTOM')"
        [disabled]="controlStates.isBottomBtnDisabled"
      ></button>
      @if (controlStates.showBottomBtn) {
        <button
          class="x_btn x_bordered icon-angle-down-line"
          (click)="scrollScreenVertically('BOTTOM')"
          [disabled]="controlStates.isBottomBtnDisabled"
        ></button>
      }
      @if (controlStates.showBottomBtnFullContent) {
        <button
          class="x_btn x_bordered icon-angle-double-down-line"
          (click)="scrollFullContentVertically('FULL_BOTTOM')"
          [disabled]="controlStates.isBottomBtnFullContentDisabled"
        ></button>
      }
    </div>
  </div>
}
@if (controlStates.isHorizontal) {
  <div class="btn-group-horizontal scroll-btn-group">
    <div class="left-holder">
      @if (controlStates.showLeftBtnFullContent) {
        <button
          class="x_btn x_bordered icon-angle-double-left-line"
          (click)="scrollFullContentHorizontally('FULL_LEFT')"
          [disabled]="controlStates.isLeftBtnFullContentDisabled"
        ></button>
      }
      @if (controlStates.showLeftBtn) {
        <button
          class="x_btn x_bordered icon-angle-left-line"
          (click)="scrollScreenHorizontally('LEFT')"
          [disabled]="controlStates.isLeftBtnDisabled"
        ></button>
      }
      <button
        class="x_btn x_bordered icon-angle-left"
        (click)="scrollStepHorizontally('LEFT')"
        [disabled]="controlStates.isLeftBtnDisabled"
      ></button>
    </div>
    <div class="right-holder">
      <button
        class="x_btn x_bordered icon-angle-right"
        (click)="scrollStepHorizontally('RIGHT')"
        [disabled]="controlStates.isRightBtnDisabled"
      ></button>
      @if (controlStates.showRightBtn) {
        <button
          class="x_btn x_bordered icon-angle-right-line"
          (click)="scrollScreenHorizontally('RIGHT')"
          [disabled]="controlStates.isRightBtnDisabled"
        ></button>
      }
      @if (controlStates.showRightBtnFullContent) {
        <button
          class="x_btn x_bordered icon-angle-double-right-line"
          (click)="scrollFullContentHorizontally('FULL_RIGHT')"
          [disabled]="controlStates.isRightBtnFullContentDisabled"
        ></button>
      }
    </div>
  </div>
}
